import PromptInput from "common/widgets/PromptList/PromptInput";
import TextInput from "app/widgets/TextInput/TextInput";
import ManyInput from "app/widgets/ManyInput/ManyInput";
import MaskedInput from "common/widgets/DFMaskedInput/DFMaskedInput";
import locale from "common/managers/locale";
import dateConvert from "common/helper/dateConvert";
import DataType from "common/enums/DataType";
import PasswordFieldDecorator from "common/widgets/PromptList/PasswordFieldDecorator";
import userSettings from "common/managers/userSettings";
import UserSettingNames from "common/enums/settings/UserSettingNames";

const StringPromptInput = PromptInput.extend({
    options: {
        name: "StringPromptInput"
    },

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        var characterCase = this.options.model.characterCase,
            hasMask = this.options.model.hasMaskValidator && this.options.model.hasMaskValidator();
        this._maskFulfilled = $.proxy(this._maskFulfilled, this);
        if (this.options.model.allowMultipleValues && !this.options.model.singleMultiValue) {
            var me = this;
            if (hasMask) {
                this.widget = new ManyInput(this.input, {
                    widget: MaskedInput,
                    widgetOptions: {
                        mask: this.options.model.getMaskFormat(),
                        fulfilled: this._maskFulfilled
                    },
                    inputCreated: function(e) {
                        e.widget.mask(me.options.model.getMaskFormat());
                        me.options.model.maskTokens = e.widget.tokens;
                        me.addFocusables([e.widget, e.add, e.remove]);
                    }
                });
            } else {
                this.widget = new ManyInput(this.input, {
                    widget: TextInput,
                    widgetOptions: {
                        maxlength: this.options.model.maxLength,
                        characterCase: characterCase
                    },
                    inputCreated: function(e) {
                        me.addFocusables([e.widget, e.add, e.remove]);
                    }
                });
            }
        } else {

            // check for mask validators
            if (hasMask) {
                this.widget = new MaskedInput(this.input, {
                    fulfilled: this._maskFulfilled
                });
                this.widget.mask(this.options.model.getMaskFormat());

                // after creating the masked input, store its tokens in the model, so we can access
                // them easily during validation.
                this.options.model.maskTokens = this.widget.tokens;
            } else {

                // figure out if we need to display as password
                if (this.options.model.password) {
                    PasswordFieldDecorator.decorate(this.input);
                }

                this.widget = new TextInput(this.input, {
                    maxlength: this.options.model.maxLength,
                    characterCase: characterCase
                });
            }
        }
        // set class needed for applying styles to set width / height / labelPosition correctly,
        // based on control type
        if (this.options.model.width && this.options.model.height) {
            this.element.parent().addClass("textFormControl flexLayout");
        }
        this.widget.bind("change", this.handleChange);

        this.refresh();
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Override
     */
    _getFocusWidgets: function(showAll) {
        if (this.options.model.allowMultipleValues && !this.options.model.singleMultiValue && this.widget) {
            return this.widget.getFocusWidgets(showAll);
        }
        return PromptInput.fn._getFocusWidgets.apply(this, arguments);
    },

    /**
     * "fulfilled" event handler for when a mask input has its mask fulfilled
     * @private
     */
    _maskFulfilled: function() {
        if(this.options.usePredictiveTabbing && userSettings.getBoolean(UserSettingNames.INDEXING_PREDICT_TAB, false)) {
            this._focusNext();
        }
    },

    // Only call readOnly when not absolutely positioned. Otherwise, enabled handling displays the readonly (disabled)
    // mode of the control. When absolutely positioned, we need to use scrolling to access the full text, rather than wrapping
    // on our own with our special readonly mode.
    readonly: function(val) {
        if (!this.options.disabledWhenReadonly) {
            PromptInput.fn.readonly.call(this, val);
        } else {
            this._readonlyEnable(val);
        }
    },

    // Format the value before displaying it in the input.
    formatValue: function(x) {
        if (this.options.model.dataType === DataType.DATE) {
            return locale.formatDate(dateConvert.toDate(x), "d");
        } else if(this.options.model.allowMultipleValues && x && x.toJSON) {
            return x.toJSON();
        } else {
            return x;
        }
    },

    // Format the value from the control before saving it.
    parseValue: function(x) {
        if (this.options.model.dataType === DataType.DATE) {
            return dateConvert.toLong(locale.parseDate(x));
        } else if(this.options.model.allowMultipleValues && (!x || !x.length)) {
            return null;
        } else {
            return x;
        }
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 20;
        return minSize;
    },

    updateStyle: function() {
        PromptInput.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
    },

    _updateStyle: function() {
        if (this.widget.characterCase) {
            this.widget.characterCase(this.options.model.characterCase);
        }
    },

    updateWidgetValue: function(value) {
        PromptInput.fn.updateWidgetValue.apply(this, arguments);
        // Mask Validators will fail to set invalid values, but the model for the PromptInput will not be updated
        // so we are updating it here, based on the value set by the actual widget.
        if(this.options.model.hasMaskValidator && this.options.model.hasMaskValidator()){
            this.options.model.value = this.widget.value();
        }
    }

});
kendo.ui.plugin(StringPromptInput);
export default StringPromptInput;
